<div class="app-toggle">
  <div class="toggle-row">
    <span *ngIf="offLabel" class="toggle-label off">{{
      offLabel | translate
    }}</span>

    <label class="switch">
      <input
        type="checkbox"
        [id]="inputId || null"
        [attr.value]="nativeValue"
        [checked]="value"
        [disabled]="disabled"
        (change)="onNativeChange($event)"
        (blur)="onTouched()"
      />
      <span class="slider round" [attr.data-testid]="testId"></span>
    </label>

    <span *ngIf="onLabel" class="toggle-label on">{{
      onLabel | translate
    }}</span>

    <span
      *ngIf="tooltip"
      class="toggle-tooltip"
      [attr.title]="tooltip | translate"
      >?</span
    >
  </div>

  <app-explanation *ngIf="helpText" [text]="helpText"></app-explanation>
</div>
